import styled from 'styled-components';

export const GenericLegend = styled.legend`
    &&& {
        margin-bottom: 0;
    }
`;

export default GenericLegend;
